import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { PROJECT_FIELDS } from '../project/projects-list/constants';
import { IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

export const getProjectsFilters = (
	filters: any[],
	accountSettings: AccountSettingsService,
	isUserRoleAdmin: boolean,
	userId: number
): any[] => {
	if (!filters || !accountSettings || IS_NULL_OR_UNDEFINED(userId)) {
		return filters || [];
	}
	if (accountSettings.NON_ADMIN_SEE_OWN_LOADS_ONLY && !isUserRoleAdmin) {
		const hasAssigneeFilter = filters.find((filter) => filter.filterField == PROJECT_FIELDS.ASSIGNED_REPS);
		if (hasAssigneeFilter) {
			return filters.map((filter) => {
				if (filter.filterField == PROJECT_FIELDS.ASSIGNED_REPS) {
					return {
						...filter,
						filterText: [userId],
						filterCondition: 'and',
					};
				}
				return filter;
			});
		}
		return [
			...filters,
			{
				endValue: '',
				filterCondition: 'and',
				filterField: PROJECT_FIELDS.ASSIGNED_REPS,
				filterText: [userId],
				isNotDeletable: false,
				operator: '',
				startValue: '',
			},
		];
	}
	return filters;
};
